module.exports = __webpack_public_path__ + "img/lpc-org-v2.dd8ab34d.jpg";